function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "var(--primary-color, #000)",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M29.988 18.483c.632-2.528 2.059-3.692 3.932-3.502C45.422 16.14 54 20.664 54 26.066c0 6.281-11.6 11.374-25.908 11.374S2.184 32.347 2.184 26.066c0-5.259 8.127-9.684 19.168-10.985 2.149-.254 4.211.875 4.843 3.402"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.185 24.802v8.847c0 6.281 11.599 11.373 25.908 11.373S54.001 39.93 54.001 33.65v-8.847"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.75 29.747c2.839-3.414 9.298-6.063 17.338-7.052 2.228-.274 4.415-1.684 5.109-4.212m3.79 0c.633 2.528 1.979 3.887 3.816 4.069 8.702.86 15.747 3.641 18.699 7.276"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 28.092,
  cy: 41.268,
  rx: 5.055,
  ry: 1.733
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "skewY(-12.875) scale(.97486 1)",
  cx: 45.022,
  cy: 48.772,
  rx: 5.186,
  ry: 1.733,
  strokeWidth: 1.013
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "skewY(12.875) scale(-.97486 1)",
  cx: -12.742,
  cy: 35.901,
  rx: 5.186,
  ry: 1.733,
  strokeWidth: 1.013
}));

var SvgBracelet = function SvgBracelet(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBracelet, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Bracelet.d635febd.svg";
export { ForwardRef as ReactComponent };